var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ItemState } from "../PickedEvent";
import { observable, action, computed } from "mobx";
export class SuperBannerJackpotItem {
    constructor(source, clientIncludeInManager) {
        this.Id = source.Id;
        this.AllowDevices = source.AllowDevices;
        this.state = ItemState.loading;
        this.SportId = source.SportId;
        this.ClientHashClass = clientIncludeInManager.getElementClass(source.HashClientIncludeIn);
        this.ClientHashAttribute = source.HashClientIncludeIn;
        this.cmsConfig = source; // we will pass later whole item to the JP component
    }
    setState(state) {
        // just keep empty it for backward compatibility
    }
    get IsLoading() {
        return this.state === ItemState.loading;
    }
    toggleAvailableState(isOn) {
        this.state = isOn ? ItemState.available : ItemState.unavailable;
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], SuperBannerJackpotItem.prototype, "state", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SuperBannerJackpotItem.prototype, "setState", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], SuperBannerJackpotItem.prototype, "IsLoading", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SuperBannerJackpotItem.prototype, "toggleAvailableState", null);
//# sourceMappingURL=SuperBannerJackpotItem.js.map